const WA_RESERVAR =
  "https://wa.me/5493415779623?text=Hola!%20Quiero%20reservar%20para%20ir%20a%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";

export default function FooterSection() {
  return (
    <footer className="bg-teal-500 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8">
            <img
              alt="MenteIA"
              className="h-32 w-auto mx-auto"
              src="https://static.readdy.ai/image/9d306f0d392a82ba4f7ef7b5bf276da1/1c933e9a80936fbdcb32303c9f264755.png"
            />
          </div>

          <h3 className="text-2xl font-bold mb-4">
            Curso presencial MenteIA en Pergamino
          </h3>
          <div className="space-y-2 text-lg mb-8">
            <p>Jueves 5 de Marzo de 2026, de 9 a 17hs</p>
            <p>LA USINA NORTE</p>
          </div>

          {/* Map */}
          <div className="bg-gray-900 rounded-xl p-8 mb-12 border border-gray-800 max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-6">
              Ubicación del evento
            </h3>
            <div className="bg-white rounded-lg overflow-hidden shadow-2xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.0847!2d-60.5689!3d-33.8897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7ab1c5e5e5e5e%3A0x5e5e5e5e5e5e5e5e!2sFloripondio%20436%2C%20B2700%20Pergamino%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses-419!2sar!4v1642000000000!5m2!1ses-419!2sar"
                width="100%"
                height={400}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación LA USINA NORTE Pergamino"
              />
            </div>
            <p className="text-white mt-6 text-lg">
              <a
                href="https://maps.app.goo.gl/aBriNh9bvfBtKG1r7"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-teal-400 transition-colors underline cursor-pointer"
              >
                FLORIPONDIO 436, B2700 Pergamino, Provincia de Buenos Aires
              </a>
            </p>
          </div>

          <div>
            <a
              href={WA_RESERVAR}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 bg-white text-teal-600 rounded-lg font-semibold text-lg hover:bg-gray-100 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-white/50"
            >
              Reservar por WhatsApp
            </a>
          </div>

          <div className="mt-8 pt-8 border-t border-white/20">
            <p className="text-sm">
              © 2026 MenteIA. Todos los derechos reservados. |{" "}
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}